'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const request = require( 'superagent');
const { object } = propTypes;
const createReactClass = require('create-react-class');

const Harp = createReactClass({
  propTypes: {
    settings: object.isRequired
  },

  getInitialState() {
    return {
      visible: false,
      message: ''
    };
  },

  response( err, res ) {
    if ( err || !( res && res.body )) return;
    const data = res.body;
    if (!data.active || data.message === '') return
    this.setState({
      visible: true,
      message: data.message
    });
  },

  componentDidMount () {
    const { domainSettings, settings } = this.props
    const requestUrlBase = Object.prototype.hasOwnProperty.call(settings, 'rpcGatewayBase') ? settings.rpcGatewayBase : ''
    const requestUrl = `${requestUrlBase}harp-alert`
    try {
      request.post(requestUrl).send({
        func: 'getDomainAlert',
        data: {
          domain: domainSettings.domain
        }
      }).end(this.response)
    } catch (e) {
      // console.log( e );
    }
  },

  closeAlert( ) {
    this.setState({
      visible: false
    });
  },

  render: function() {
    const { visible, message } = this.state;
    if ( !visible || message === '' ) return null;
    return (
      <div id="harpAlert" className="custom-alert alert">
        <button type="button" className="close" data-dismiss="alert" onClick={ this.closeAlert }>X</button>
        <h4>
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </h4>
      </div>
    );
  }
});

module.exports = Harp;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/harp-alert.jsx